module.exports = "input.ng-invalid.ant-input {\n  border-color: red;\n}\n.readonly-number-format-in-editor {\n  line-height: 26px;\n  padding-right: 11px;\n}\n"